import { render, staticRenderFns } from "./ReportLight.vue?vue&type=template&id=bdced1f4"
import script from "./ReportLight.vue?vue&type=script&lang=js"
export * from "./ReportLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports